const api = `${process.env.PUBLIC_URL}/api`;
export const TaskApi = `${api}/tasks.json`;
export const ProductApi = `${api}/product.json`;
export const ContactsApi = `${api}/contacts.json`;
export const ChatApi = `${api}/chats.json`;
export const ChatMemberApi = `${api}/chatmemberapi.json`;

